import { config } from "@/config";

interface RequestInitWithJson extends RequestInit {
	json?: any;
}

/**
 * Public API fetch without authentication (for start_call endpoint)
 */
export const apiFetch = (
	method: string,
	endpoint: string,
	options: RequestInitWithJson = {},
): Promise<any> => {
	const headers = {
		...options.headers,
		"Content-Type": "application/json",
	};

	const body = options.json ? JSON.stringify(options.json) : undefined;

	const url = `${config.api.base_url}${config.api.prefix}${endpoint}`;
	console.info(`[apiConfig]: ${method} ${url}`);

	return fetch(url, {
		method,
		...options,
		headers: headers as HeadersInit,
		body: body as BodyInit | null,
	})
		.then(async (response) => {
			if (!response.ok) {
				const errorData = await response.json().catch(() => null);
				return Promise.reject({
					error: errorData?.detail || response.statusText,
					code: response.status,
				});
			}

			if (response.status === 204) {
				return Promise.resolve(null);
			}

			return Promise.resolve(response.json());
		})
		.catch((error) => {
			return Promise.reject(error);
		});
};
